import { useEffect } from 'react'
import { FeatureFlagsContextValue } from './types'

/**
 * Records org-specific feature flags (from /org-settings/feature-flags API) to Meticulous.
 * This complements the LaunchDarkly inspector which records LD flags.
 */
export const useRecordFeatureFlagsToMeticulous = (featureFlags: FeatureFlagsContextValue) => {
  useEffect(() => {
    // Only record if Meticulous is loaded
    if (!window.Meticulous?.context) {
      return
    }

    const meticulous = window.Meticulous.context

    try {
      // Record all custom feature flags to Meticulous
      Object.entries(featureFlags).forEach(([flagKey, flagValue]) => {
        // Prefix with 'org-settings:' to distinguish from LaunchDarkly flags
        meticulous.recordFeatureFlag(`org-settings:${flagKey}`, flagValue)
      })
    } catch (error) {
      console.error('[Meticulous] Failed to record custom feature flags:', error)
    }
  }, [featureFlags])
}
